// Сетка выбора типа нового блока — первый шаг ручного создания.
import type { SegmentKind } from '../../types';
import { KindIcon } from '../library/KindIcon';
import { useT } from '../../i18n';
import styles from './KindPicker.module.css';

export interface KindPickerProps {
  onPick(kind: SegmentKind): void;
  /**
   * Открыть распознавание источника вместо ручного выбора типа. Распознавание —
   * другой способ завести блок, а не восьмой тип в сетке, поэтому вход стоит
   * отдельной строкой под ней, за волосяным разделителем. Необязателен: без
   * колбэка строка просто не рисуется (так KindPicker остаётся пригодным для
   * мест, которым распознавание не нужно).
   */
  onPickSource?(): void;
}

/** Подписи и описания берутся из словаря по ключам kind.* и kind.*.desc. */
const KINDS: readonly SegmentKind[] = [
  'flight',
  'transfer',
  'lodging',
  'taxi',
  'food',
  'baggage',
  'misc',
];

export function KindPicker({ onPick, onPickSource }: KindPickerProps) {
  const t = useT();
  return (
    <div>
      <div className={styles.grid}>
        {KINDS.map((kind) => (
          <button key={kind} type="button" className={styles.item} onClick={() => onPick(kind)}>
            <span className={styles.head}>
              <KindIcon kind={kind} size={18} />
              <span className={styles.label}>{t(`kind.${kind}`)}</span>
            </span>
            <span className={styles.desc}>{t(`kind.${kind}.desc`)}</span>
          </button>
        ))}
      </div>
      {onPickSource && (
        <div className={styles.sourceRow}>
          <button type="button" className={styles.sourceBtn} onClick={onPickSource}>
            <span className={styles.sourceLabel}>{t('library.fromSource')}</span>
            <span className={styles.sourceDesc}>{t('library.fromSource.desc')}</span>
          </button>
        </div>
      )}
    </div>
  );
}
